module.exports = __webpack_public_path__ + "img/bbc.a42b4a99.png";